module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp1_9006.f45f1e8f.png";